<template>
  <base-page-layout title="Campanha da mar.ia">
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" />
      <div class="tab-buttons">
        <mf-button v-if="tab !== 2" data-cy="newOffer" icon="add" label="Nova campanha" @click="redirect" />
      </div>
    </div>

    <campaign-index-table :tab="tab" />
  </base-page-layout>
</template>

<script>
import { mapMutations } from 'vuex'

import BasePageLayout from '@/components/BasePageLayout.vue'
import CampaignIndexTable from '@/modules/maria/campanha-da-maria/views/components/CampaignIndexTable.vue'

export default {
  name: 'MariaCampaign',
  components: {
    BasePageLayout,
    CampaignIndexTable,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          name: 'Ofertas ativas',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['RESET_MARIA_CAMPAIGN_MODULE']),

    redirect() {
      this.RESET_MARIA_CAMPAIGN_MODULE()
      this.$router.push({ name: 'New Mar.ia campaign' })
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .tab-buttons {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
